var _line, _line2, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSignsCollection = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 110,
    viewBox: "0 0 100 110",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 14,
    x2: 22,
    y2: 43,
    stroke: "#D28A60",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: 14,
    x2: 78,
    y2: 43,
    stroke: "#D28A60",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 12,
    r: 4,
    fill: "#D28A60"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 25,43 L 75,43 A 9,9 0 0,0 84,52 L 84,82 A 9,9 0 0,0 75,91 L 25,91 A 9,9 0 0,0 16,82 L 16,52 A 9,9 0 0,0 25,43 Z",
    stroke: "#D28A60",
    strokeWidth: 4.5,
    fill: "none",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSignsCollection);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/signs-collection.eb1c6ec513cb103bb9b9e59502b92323.svg";